<template>
  <Page>
    <Columns gap="small" class="my-6">
      <!-- Code Column -->
      <Column width="2/3" class="relative block overflow-hidden h-full text-[13px] leading-[18px] rounded-lg border border-gray-100/50 bg-white dark:bg-linear-to-r dark:from-slate-900 dark:to-slate-700 p-4 pb-7">
        <Box v-slot="{ elementWidth }" marginTop="xsmall">
          <Box full justifyContent="between" marginBottom="gutter" gapY="gutter" noWrap :shouldCollapse="elementWidth < 400">
            <Box gap="small" :shouldCollapse="elementWidth < 330">
              <!-- Button Prop Sidebar -->
              <Box>
                <Drawer v-model="openButtonPropSidebar" heading="Text Props">
                  <Stack gap="xsmall">
                    <Text marginY="small" attention>
                      Below are all available props to the Text Component.
                    </Text>

                    <Stack gap="medium">
                      <!-- Checkboxes for Other Props -->
                      <Stack gap="small">
                        <Checkbox v-model="state.attention" label="Attention" binary/>
                        <Checkbox v-model="state.italic" label="Italic" binary />
                        <Stack>
                          <Checkbox v-model="state.center" label="Center" binary/>
                          <Text size="xsmall" color="dark">(Only works with HTML elements, not Layout Components)</Text>
                        </Stack>
                      </Stack>

                      <!-- Select for Color Prop -->
                      <Stack class="sm:w-[14rem]">
                        <Label>Text Colors</Label>
                        <Select
                          v-model="state.textColor"
                          :options="textColors"
                        />
                      </Stack>

                      <!-- Select for Size Prop -->
                      <Stack class="sm:w-[14rem]">
                        <Label>Text Sizes</Label>
                        <Select
                          v-model="state.textSize"
                          :options="textSizes"
                        />
                      </Stack>

                      <!-- Select for Weight Prop -->
                      <Stack class="sm:w-[14rem]">
                        <Label>Text Weight</Label>
                        <Select
                          v-model="state.textWeight"
                          :options="textWeights"
                        />
                      </Stack>

                      <!-- Select for Color Prop -->
                      <Stack class="sm:w-[14rem]">
                        <Label>Text Hover Color</Label>
                        <Select
                          v-model="state.hoverColor"
                          :options="textColors"
                          placeholder="Select One"
                        />
                      </Stack>

                      <Text marginTop="large" attention>
                        Below are all available Margin Props.
                      </Text>

                      <!-- Select for Margin Prop -->
                      <Stack class="sm:w-[14rem]">
                        <Label>Margin</Label>
                        <Select
                          v-model="state.margin"
                          :options="layoutSizes"
                          placeholder="Select One"
                        />
                      </Stack>

                      <!-- Select for Margin X Prop -->
                      <Stack class="sm:w-[14rem]">
                        <Label>Margin X</Label>
                        <Select
                          v-model="state.marginX"
                          :options="layoutSizes"
                          placeholder="Select One"
                        />
                      </Stack>

                      <!-- Select for Margin Y Prop -->
                      <Stack class="sm:w-[14rem]">
                        <Label>Margin Y</Label>
                        <Select
                          v-model="state.marginY"
                          :options="layoutSizes"
                          placeholder="Select One"
                        />
                      </Stack>

                      <!-- Select for Margin Left Prop -->
                      <Stack class="sm:w-[14rem]">
                        <Label>Margin Left</Label>
                        <Select
                          v-model="state.marginLeft"
                          :options="layoutSizes"
                          placeholder="Select One"
                        />
                      </Stack>

                      <!-- Select for Margin Right Prop -->
                      <Stack class="sm:w-[14rem]">
                        <Label>Margin Right</Label>
                        <Select
                          v-model="state.marginRight"
                          :options="layoutSizes"
                          placeholder="Select One"
                        />
                      </Stack>

                      <!-- Select for Margin Top Prop -->
                      <Stack class="sm:w-[14rem]">
                        <Label>Margin Top</Label>
                        <Select
                          v-model="state.marginTop"
                          :options="layoutSizes"
                          placeholder="Select One"
                        />
                      </Stack>

                      <!-- Select for Margin Bottom Prop -->
                      <Stack class="sm:w-[14rem]">
                        <Label>Margin Bottom</Label>
                        <Select
                          v-model="state.marginBottom"
                          :options="layoutSizes"
                          placeholder="Select One"
                        />
                      </Stack>

                      <Text marginTop="large" attention>
                        Below are all available Padding Props.
                      </Text>

                      <!-- Select for Padding Prop -->
                      <Stack class="sm:w-[14rem]">
                        <Label>Padding</Label>
                        <Select
                          v-model="state.padding"
                          :options="layoutSizes"
                          placeholder="Select One"
                        />
                      </Stack>

                      <!-- Select for Padding X Prop -->
                      <Stack class="sm:w-[14rem]">
                        <Label>Padding X</Label>
                        <Select
                          v-model="state.paddingX"
                          :options="layoutSizes"
                          placeholder="Select One"
                        />
                      </Stack>

                      <!-- Select for Padding Y Prop -->
                      <Stack class="sm:w-[14rem]">
                        <Label>Padding Y</Label>
                        <Select
                          v-model="state.paddingY"
                          :options="layoutSizes"
                          placeholder="Select One"
                        />
                      </Stack>

                      <!-- Select for Padding Left Prop -->
                      <Stack class="sm:w-[14rem]">
                        <Label>Padding Left</Label>
                        <Select
                          v-model="state.paddingLeft"
                          :options="layoutSizes"
                          placeholder="Select One"
                        />
                      </Stack>

                      <!-- Select for Padding Right Prop -->
                      <Stack class="sm:w-[14rem]">
                        <Label>Padding Right</Label>
                        <Select
                          v-model="state.paddingRight"
                          :options="layoutSizes"
                          placeholder="Select One"
                        />
                      </Stack>

                      <!-- Select for Padding Top Prop -->
                      <Stack class="sm:w-[14rem]">
                        <Label>Padding Top</Label>
                        <Select
                          v-model="state.paddingTop"
                          :options="layoutSizes"
                          placeholder="Select One"
                        />
                      </Stack>

                      <!-- Select for Padding Bottom Prop -->
                      <Stack class="sm:w-[14rem]">
                        <Label>Padding Bottom</Label>
                        <Select
                          v-model="state.paddingBottom"
                          :options="layoutSizes"
                          placeholder="Select One"
                        />
                      </Stack>
                    </Stack>
                  </Stack>
                  <!-- Open Sidebar -->
                </Drawer>

                <Box @click="openButtonPropSidebar = true" justifyContent="center" class="text-sm text-slate-100 font-attention rounded-sm px-3 py-1 cursor-pointer bg-slate-500/75 border border-slate-400/50" :full="elementWidth < 330">
                  Text Props
                </Box>
              </Box>
              <!-- Reset Playground -->
              <p @click="resetPlayground" class="bg-red-700 px-3 py-1 text-sm text-center text-slate-100 font-attention rounded-sm cursor-pointer hover:bg-red-800">Reset</p>
            </Box>
            <!-- Import Statement Copy Button -->
            <Button
                @click="copy(importStatement)"
                color="gray"
                size="sm"
                outline
              >
              {{ copied ? 'Copied Import' : 'Copy Import' }}
            </Button>
          </Box>
        </Box>

        <!-- View HTML -->
          <div>
            <!-- Button Opening Tag -->
            <pre>&lt;<span class="text-lime-600 dark:text-lime-600 font-semibold">Text</span><span v-if="shouldShowNoPropClosingCarrot">&gt;</span></pre>
            <!-- Optional props -->
            <pre v-if="(state.textColor !== 'default' && state.textColor !== null)"><span class="text-orange-600 dark:text-orange-400 ml-2">color</span><span>="{{ state.textColor }}"</span></pre>
            <pre v-if="state.textSize !== 'base'"><span class="text-orange-600 dark:text-orange-400 ml-2">size</span><span>="{{ state.textSize }}"</span></pre>
            <pre v-if="state.textWeight !== 'normal'"><span class="text-orange-600 dark:text-orange-400 ml-2">weight</span><span>="{{ state.textWeight }}"</span></pre>
            <pre v-if="state.hoverColor"><span class="text-orange-600 dark:text-orange-400 ml-2">hover</span><span>="{{ state.hoverColor }}"</span></pre>
            <pre v-if="state.italic"><span class="text-orange-600 dark:text-orange-400 ml-2">italic</span></pre>
            <pre v-if="state.attention"><span class="text-orange-600 dark:text-orange-400 ml-2">attention</span></pre>
            <pre v-if="state.center"><span class="text-orange-600 dark:text-orange-400 ml-2">center</span></pre>
            <pre v-if="state.margin"><span class="text-orange-600 dark:text-orange-400 ml-2">margin</span><span>="{{ state.margin }}"</span></pre>
            <pre v-if="state.marginX"><span class="text-orange-600 dark:text-orange-400 ml-2">marginX</span><span>="{{ state.marginX }}"</span></pre>
            <pre v-if="state.marginY"><span class="text-orange-600 dark:text-orange-400 ml-2">marginY</span><span>="{{ state.marginY }}"</span></pre>
            <pre v-if="state.marginLeft"><span class="text-orange-600 dark:text-orange-400 ml-2">marginLeft</span><span>="{{ state.marginLeft }}"</span></pre>
            <pre v-if="state.marginRight"><span class="text-orange-600 dark:text-orange-400 ml-2">marginRight</span><span>="{{ state.marginRight }}"</span></pre>
            <pre v-if="state.marginTop"><span class="text-orange-600 dark:text-orange-400 ml-2">marginTop</span><span>="{{ state.marginTop }}"</span></pre>
            <pre v-if="state.marginBottom"><span class="text-orange-600 dark:text-orange-400 ml-2">marginBottom</span><span>="{{ state.marginBottom }}"</span></pre>
            <pre v-if="state.padding"><span class="text-orange-600 dark:text-orange-400 ml-2">padding</span><span>="{{ state.padding }}"</span></pre>
            <pre v-if="state.paddingX"><span class="text-orange-600 dark:text-orange-400 ml-2">paddingX</span><span>="{{ state.paddingX }}"</span></pre>
            <pre v-if="state.paddingY"><span class="text-orange-600 dark:text-orange-400 ml-2">paddingY</span><span>="{{ state.paddingY }}"</span></pre>
            <pre v-if="state.paddingLeft"><span class="text-orange-600 dark:text-orange-400 ml-2">paddingLeft</span><span>="{{ state.paddingLeft }}"</span></pre>
            <pre v-if="state.paddingRight"><span class="text-orange-600 dark:text-orange-400 ml-2">paddingRight</span><span>="{{ state.paddingRight }}"</span></pre>
            <pre v-if="state.paddingTop"><span class="text-orange-600 dark:text-orange-400 ml-2">paddingTop</span><span>="{{ state.paddingTop }}"</span></pre>
            <pre v-if="state.paddingBottom"><span class="text-orange-600 dark:text-orange-400 ml-2">paddingBottom</span><span>="{{ state.paddingBottom }}"</span></pre>
            <pre v-if="!shouldShowNoPropClosingCarrot">&gt;</pre>
            <pre><span> This is a sample text!</span></pre>
            <!-- Button Closing Tag -->
            <pre class="mt-1">&lt;/<span class="text-lime-600 dark:text-lime-600 font-semibold">Text</span>&gt;</pre>
          </div>

        <!-- Bottom gradient bar -->
        <span class="absolute inset-x-0 bottom-0 h-2 bg-linear-to-r from-green-300 via-blue-500 to-purple-600"/>
      </Column>

      <!-- Visual Block -->
      <Column class="h-72 p-4 bg-white dark:bg-charcoal-900 rounded-lg border border-gray-100/50">
        <Box justifyContent="center" alignItems="center" class="h-full">
          <Text
            :color="state.textColor"
            :size="state.textSize"
            :weight="state.textWeight"
            :hover="state.hoverColor"
            :italic="state.italic"
            :attention="state.attention"
            :center="state.center"
          >
            <div class="border-orange-400/85" :class="marginDimensions">
              <div class="border-lime-300/85" :class="paddingDimensions">
                <div>This is a sample text!</div>
              </div>
            </div>
          </Text>
        </Box>
      </Column>
    </Columns>
  </Page>
</template>

<script setup>
import { ref, computed } from 'vue'
import { Box, Column, Columns, Page, Stack } from '@/components/Core/Layout'
import Drawer from '@/components/Core/Drawer.vue'
import Select from '@/components/Core/Form/Select.vue'
import Text from '@/components/Core/Text.vue'
import Checkbox from '@/components/Core/Form/Checkbox.vue'
import Label from '@/components/Core/Form/Label.vue'
import Button from '@/components/Core/Button.vue'
import { useClipboard } from '@vueuse/core'

const importStatement = ref('import Text from \'@/components/Core/Text.vue\'')
const { copy, copied } = useClipboard({ importStatement })

const openButtonPropSidebar = ref(false)

const state = ref({
  textColor: 'default',
  hoverColor: null,
  textSize: 'base',
  textWeight: 'normal',
  italic: false,
  attention: false,
  center: false,
  margin: null,
  marginX: null,
  marginY: null,
  marginLeft: null,
  marginRight: null,
  marginTop: null,
  marginBottom: null,
  padding: null,
  paddingX: null,
  paddingY: null,
  paddingLeft: null,
  paddingRight: null,
  paddingTop: null,
  paddingBottom: null
})

const initialState = ref(JSON.parse(JSON.stringify(state.value)))

const textColors = ref([
  { label: 'amber', value: 'amber' },
  { label: 'dark', value: 'dark' },
  { label: 'default', value: 'default' },
  { label: 'green', value: 'green' },
  { label: 'light', value: 'light' },
  { label: 'purple', value: 'purple' },
  { label: 'red', value: 'red' },
  { label: 'white', value: 'white' }
])

const textSizes = ref([
  { label: 'xsmall', value: 'xsmall' },
  { label: 'small', value: 'small' },
  { label: 'base', value: 'base' },
  { label: 'large', value: 'large' },
  { label: 'xlarge', value: 'xlarge' }
])

const textWeights = ref([
  { label: 'light', value: 'light' },
  { label: 'normal', value: 'normal' },
  { label: 'medium', value: 'medium' },
  { label: 'semibold', value: 'semibold' },
  { label: 'bold', value: 'bold' }
])

const layoutSizes = ref([
  { label: 'xxsmall', value: 'xxsmall' },
  { label: 'xsmall', value: 'xsmall' },
  { label: 'small', value: 'small' },
  { label: 'medium', value: 'medium' },
  { label: 'large', value: 'large' },
  { label: 'xlarge', value: 'xlarge' },
  { label: 'xxlarge', value: 'xxlarge' },
  { label: 'gutter', value: 'gutter' }
])

const shouldShowNoPropClosingCarrot = computed(() => {
  return (state.value.textColor === 'default' || state.value.textColor === null) &&
    !state.value.hoverColor &&
    state.value.textSize === 'base' &&
    state.value.textWeight === 'normal' &&
    !state.value.italic &&
    !state.value.attention &&
    !state.value.center &&
    !state.value.margin &&
    !state.value.marginX &&
    !state.value.marginY &&
    !state.value.marginLeft &&
    !state.value.marginRight &&
    !state.value.marginTop &&
    !state.value.marginBottom &&
    !state.value.padding &&
    !state.value.paddingX &&
    !state.value.paddingY &&
    !state.value.paddingLeft &&
    !state.value.paddingRight &&
    !state.value.paddingTop &&
    !state.value.paddingBottom
})

const resetPlayground = () => {
  state.value = JSON.parse(JSON.stringify(initialState.value))
}

/**
 * DIMENSIONS
*/
const marginDimensions = computed(() => {
  let margin = {
    xxsmall: 'p-1',
    xsmall: 'p-2',
    small: 'p-3',
    medium: 'p-4',
    large: 'p-6',
    xlarge: 'p-8',
    xxlarge: 'p-10',
    gutter: 'p-5'
  }[state.value.margin]

  let marginX = {
    xxsmall: 'px-1',
    xsmall: 'px-2',
    small: 'px-3',
    medium: 'px-4',
    large: 'px-6',
    xlarge: 'px-8',
    xxlarge: 'px-10',
    gutter: 'px-5'
  }[state.value.marginX]

  let marginY = {
    xxsmall: 'py-1',
    xsmall: 'py-2',
    small: 'py-3',
    medium: 'py-4',
    large: 'py-6',
    xlarge: 'py-8',
    xxlarge: 'py-10',
    gutter: 'py-5'
  }[state.value.marginY]

  let marginLeft = {
    xxsmall: 'pl-1',
    xsmall: 'pl-2',
    small: 'pl-3',
    medium: 'pl-4',
    large: 'pl-6',
    xlarge: 'pl-8',
    xxlarge: 'pl-10',
    gutter: 'pl-5'
  }[state.value.marginLeft]

  let marginRight = {
    xxsmall: 'pr-1',
    xsmall: 'pr-2',
    small: 'pr-3',
    medium: 'pr-4',
    large: 'pr-6',
    xlarge: 'pr-8',
    xxlarge: 'pr-10',
    gutter: 'pr-5'
  }[state.value.marginRight]

  let marginTop = {
    xxsmall: 'pt-1',
    xsmall: 'pt-2',
    small: 'pt-3',
    medium: 'pt-4',
    large: 'pt-6',
    xlarge: 'pt-8',
    xxlarge: 'pt-10',
    gutter: 'pt-5'
  }[state.value.marginTop]

  let marginBottom = {
    xxsmall: 'pb-1',
    xsmall: 'pb-2',
    small: 'pb-3',
    medium: 'pb-4',
    large: 'pb-6',
    xlarge: 'pb-8',
    xxlarge: 'pb-10',
    gutter: 'pb-5'
  }[state.value.marginBottom]

  /**
   * Take all margins and remove the undefineds for those not selected
  */
  let marginsToArray =  [margin, marginX, marginY, marginLeft, marginRight, marginTop, marginBottom].filter(Boolean)

  /**
   * If array has length, create a string not separateed by ','.
  */
  if (marginsToArray.length) {
    return `border-dotted border-2 ${marginsToArray.toString().split(',').join(' ')}`
  }

  return null
})

const paddingDimensions = computed(() => {
  let padding = {
    xxsmall: 'p-1',
    xsmall: 'p-2',
    small: 'p-3',
    medium: 'p-4',
    large: 'p-6',
    xlarge: 'p-8',
    xxlarge: 'p-10',
    gutter: 'p-5'
  }[state.value.padding]

  let paddingX = {
    xxsmall: 'px-1',
    xsmall: 'px-2',
    small: 'px-3',
    medium: 'px-4',
    large: 'px-6',
    xlarge: 'px-8',
    xxlarge: 'px-10',
    gutter: 'px-5'
  }[state.value.paddingX]

  let paddingY = {
    xxsmall: 'py-1',
    xsmall: 'py-2',
    small: 'py-3',
    medium: 'py-4',
    large: 'py-6',
    xlarge: 'py-8',
    xxlarge: 'py-10',
    gutter: 'py-5'
  }[state.value.paddingY]

  let paddingLeft = {
    xxsmall: 'pl-1',
    xsmall: 'pl-2',
    small: 'pl-3',
    medium: 'pl-4',
    large: 'pl-6',
    xlarge: 'pl-8',
    xxlarge: 'pl-10',
    gutter: 'pl-5'
  }[state.value.paddingLeft]

  let paddingRight = {
    xxsmall: 'pr-1',
    xsmall: 'pr-2',
    small: 'pr-3',
    medium: 'pr-4',
    large: 'pr-6',
    xlarge: 'pr-8',
    xxlarge: 'pr-10',
    gutter: 'pr-5'
  }[state.value.paddingRight]

  let paddingTop = {
    xxsmall: 'pt-1',
    xsmall: 'pt-2',
    small: 'pt-3',
    medium: 'pt-4',
    large: 'pt-6',
    xlarge: 'pt-8',
    xxlarge: 'pt-10',
    gutter: 'pt-5'
  }[state.value.paddingTop]

  let paddingBottom = {
    xxsmall: 'pb-1',
    xsmall: 'pb-2',
    small: 'pb-3',
    medium: 'pb-4',
    large: 'pb-6',
    xlarge: 'pb-8',
    xxlarge: 'pb-10',
    gutter: 'pb-5'
  }[state.value.paddingBottom]

  /**
   * Take all paddings and remove the undefineds for those not selected
  */
  let paddingsToArray =  [padding, paddingX, paddingY, paddingLeft, paddingRight, paddingTop, paddingBottom].filter(Boolean)

  /**
   * If array has length, create a string not separateed by ','.
  */
  if (paddingsToArray.length) {
    return `border-dotted border-2 ${paddingsToArray.toString().split(',').join(' ')}`
  }

  return null
})
</script>